export type EstimateErrorCode = 12 | 30 | 31 | 29 | 21 | 22 | 25 | 27 | 28 | 36 | 37 | 38 | 39 | 40 | 16

export const estimateErrors: Record<EstimateErrorCode, string> & Object = {
  12: 'Ошибка авторизации',
  16: 'Запрос на вступление уже отправлен',
  30: 'Адрес доставки не найден',
  31: 'Пункт выдачи не найден',
  29: 'Укажите адресс доставки, либо выберите пункт выдачи',
  21: 'Пустая корзина',
  22: 'закончился',
  25: 'Ингредиент является обязательным',
  27: 'Нельзя выбрать данный ингредиент в данной опции',
  28: 'Базовая модификация не выбрана',
  36: 'Промокод больше не действителен',
  37: 'Промокод не найден',
  38: 'Промокод не для вас',
  39: 'В заказе отсутствуют требуемые товары для применения промокода',
  40: 'Сумма заказа меньше необходимой для применения промокода',
}
